import { NotificationStyles } from "src/contexts/_shared/domain/NotificationStyles";
import { DocumentationAreaNotificationTypes } from "../domain/DocumentationAreaNotification";

const UNIDENTIFIED_FILE = "documentation_area.notifications.type.unidentified_document.title";
const EXPIRED_FILE = "documentation_area.notifications.type.expired_document.title";
const ID_NUMBER_DOES_NOT_MATCH =
  "documentation_area.notifications.type.id_number_does_not_match.title";
const ID_NUMBER_DOES_NOT_MATCH_FOR_COMPANY =
  "documentation_area.notifications.type.company.id_number_does_not_match.title";
const MODEL_EXPIRED_VALIDATION_DATA =
  "documentation_area.notifications.type.expired_validation_data.title";
const PAYSLIP_DUPLICATE_DOCUMENT =
  "documentation_area.notifications.type.payslip_duplicate_document.title";
const MODEL_NOT_REQUESTED = "documentation_area.notifications.type.document_not_requested.title";
const PAYSLIP_MISSING_ESSENTIAL_DATA =
  "documentation_area.notifications.type.missing_essential_data.title";
const MAX_DOCUMENT_UPLOADS_PER_ACTOR_EXCEEDED =
  "documentation_area.notifications.type.max_document_uploads_per_actor_exceeded.title";
const IDENTITY_VERIFICATION_REQUEST_FAILED =
  "documentation_area.notifications.type.identity_verification_request_failed.title";
const IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID =
  "documentation_area.notifications.type.id_number_does_not_match.title";
const INVALIDATED_BY_CUSTOMER =
  "documentation_area.notifications.type.invalidated_by_customer.title";
const VALIDATED_BY_CUSTOMER = "documentation_area.notifications.type.validated_by_customer.title";
const MODEL_ADMINISTRATION_UNAVAILABLE =
  "documentation_area.notifications.type.unavailable_administration.title";
const MODEL_GENERATED_TOO_LONG_AGO =
  "documentation_area.notifications.type.model_generated_too_long_ago.title";
const MODEL_REQUEST_SUCCEEDED =
  "documentation_area.notifications.type.model_request_succeeded.title";
const PAYSLIP_REQUEST_SUCCEEDED =
  "documentation_area.notifications.type.payslip_request_succeeded.title";
const IDENTITY_VERIFICATION_REQUEST_SUCCEEDED =
  "documentation_area.notifications.type.identity_verification_request_succeeded.title";
const OTHER_DOCUMENT_REQUEST_SUCCEEDED =
  "documentation_area.notifications.type.other_document_request_succeeded.title";
const ORDER_MODEL_ALREADY_HAS_RESPONSE =
  "documentation_area.notifications.type.order_model_already_has_response.title";
const REQUEST_SUCCEEDED = "documentation_area.notifications.type.request_succeeded.title";
const MODEL_GENERIC = "documentation_area.notifications.type.generic.title";
const MODEL_REQUEST_PENDING_EXTRACTION_ASYNC =
  "documentation_area.notifications.type.pending_to_be_extracted.title";

const DocumentationAreaNotificationTypeToNotificationInfo = {
  [DocumentationAreaNotificationTypes.UNIDENTIFIED_DOCUMENT]: {
    title: UNIDENTIFIED_FILE,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.MODEL_NOT_REQUESTED]: {
    title: MODEL_NOT_REQUESTED,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.EXPIRED_DOCUMENT]: {
    title: EXPIRED_FILE,
    style: NotificationStyles.WARNING,
  },
  [DocumentationAreaNotificationTypes.ID_NUMBER_DOES_NOT_MATCH]: {
    title: ID_NUMBER_DOES_NOT_MATCH,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.ID_NUMBER_DOES_NOT_MATCH_FOR_COMPANY]: {
    title: ID_NUMBER_DOES_NOT_MATCH_FOR_COMPANY,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.PAYSLIP_MISSING_ESSENTIAL_DATA]: {
    title: PAYSLIP_MISSING_ESSENTIAL_DATA,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.PAYSLIP_DUPLICATE_DOCUMENT]: {
    title: PAYSLIP_DUPLICATE_DOCUMENT,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.MODEL_EXPIRED_VALIDATION_DATA]: {
    title: MODEL_EXPIRED_VALIDATION_DATA,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.MAX_DOCUMENT_UPLOADS_PER_ACTOR_EXCEEDED]: {
    title: MAX_DOCUMENT_UPLOADS_PER_ACTOR_EXCEEDED,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.IDENTITY_VERIFICATION_REQUEST_FAILED]: {
    title: IDENTITY_VERIFICATION_REQUEST_FAILED,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID]: {
    title: IDENTITY_VERIFICATION_RESULT_DOES_NOT_MATCH_ID,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.INVALIDATED_BY_CUSTOMER]: {
    title: INVALIDATED_BY_CUSTOMER,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.VALIDATED_BY_CUSTOMER]: {
    title: VALIDATED_BY_CUSTOMER,
    style: NotificationStyles.SUCCESS,
  },
  [DocumentationAreaNotificationTypes.MODEL_ADMINISTRATION_UNAVAILABLE]: {
    title: MODEL_ADMINISTRATION_UNAVAILABLE,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.MODEL_GENERATED_TOO_LONG_AGO]: {
    title: MODEL_GENERATED_TOO_LONG_AGO,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.MODEL_REQUEST_SUCCEEDED]: {
    title: MODEL_REQUEST_SUCCEEDED,
    style: NotificationStyles.SUCCESS,
  },
  [DocumentationAreaNotificationTypes.PAYSLIP_REQUEST_SUCCEEDED]: {
    title: PAYSLIP_REQUEST_SUCCEEDED,
    style: NotificationStyles.SUCCESS,
  },
  [DocumentationAreaNotificationTypes.IDENTITY_VERIFICATION_REQUEST_SUCCEEDED]: {
    title: IDENTITY_VERIFICATION_REQUEST_SUCCEEDED,
    style: NotificationStyles.SUCCESS,
  },
  [DocumentationAreaNotificationTypes.OTHER_DOCUMENT_REQUEST_SUCCEEDED]: {
    title: OTHER_DOCUMENT_REQUEST_SUCCEEDED,
    style: NotificationStyles.SUCCESS,
  },
  [DocumentationAreaNotificationTypes.ORDER_MODEL_ALREADY_HAS_RESPONSE]: {
    title: ORDER_MODEL_ALREADY_HAS_RESPONSE,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.PENDING_REVIEW_FROM_ADMIN]: {
    title: REQUEST_SUCCEEDED,
    style: NotificationStyles.SUCCESS,
  },
  [DocumentationAreaNotificationTypes.MODEL_GENERIC]: {
    title: MODEL_GENERIC,
    style: NotificationStyles.ALERT,
  },
  [DocumentationAreaNotificationTypes.MODEL_REQUEST_PENDING_EXTRACTION_ASYNC]: {
    title: MODEL_REQUEST_PENDING_EXTRACTION_ASYNC,
    style: NotificationStyles.WARNING,
  },
};

export function getNotificationInfoFromDocumentationAreaNotificationType(
  type: DocumentationAreaNotificationTypes,
) {
  return DocumentationAreaNotificationTypeToNotificationInfo[type];
}
